<template>
  <section class="task-chat task-history" data-qid="task-rail-history">
    <header class="task-chat__head">
      <div class="task-chat__title">
        <h4><font-awesome-icon icon="history" class="mr-2"/>{{ $t('tasks.v2.history') }}</h4>
        <span class="task-chat__sub" v-if="loaded">{{ $tc('tasks.v2.history_count', total, { count: total }) }}</span>
      </div>
      <span class="v2-field__icon task-history__close"
            @click="$emit('close')"
            v-b-tooltip.hover
            :title="$t('system.close')"
            data-qid="task-history-close"
      ><font-awesome-icon icon="times"/></span>
    </header>

    <div class="task-history__list" data-qid="task-history-list">
      <ActivityFeed compact
                    :source="load"
                    :reload-key="taskStamp"
                    :empty-text="$t('tasks.v2.history_empty')"
      />
    </div>
  </section>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import ActivityFeed from '@/components/activity/feed/ActivityFeed.vue';

// The task's own history, newest first, in the shared activity log design
export default {
  name: 'EngagementTaskHistory',
  mixins: [assessmentSingleTaskProxy],
  components: {
    ActivityFeed
  },
  data() {
    return {
      total: 0,
      loaded: false,
      taskStamp: ''
    };
  },
  computed: {
    taskId() {
      return this.selectedTask && this.selectedTask.id;
    }
  },
  methods: {
    load(page) {
      return piincHttp.get('tasks/' + this.taskId + '/history', { params: { page: page, per_page: 25 } }).then(({ data }) => {
        this.total = data.total_count;
        this.loaded = true;
        return data;
      });
    }
  },
  created() {
    // Watched here: the task host's fields are proxied by the mixin's created hook, which runs first.
    // Saving the task or changing a test's status adds an entry.
    this.$watch(() => {
      const tests = (this.tests || []).map(test => test.id + ':' + test.status).join(',');
      return this.taskId + '|' + (this.selectedTask && this.selectedTask.updated_at) + '|' + tests;
    }, stamp => {
      this.taskStamp = stamp;
    }, { immediate: true });
  }
};
</script>
